import { WindIcon } from "components/wind-icon"
import initSwellIcons from "components/swell-icon"
import Units from "utils/units" // eslint-disable-line import/no-named-as-default

const swellKeys = ["wave-height", "surf-swell-1", "surf-swell-2", "surf-swell-3", "surf-swell-w"]

const keys = [
  "time",
  "rating",
  "maps",
  "periods",
  "wave-graph",
  "energy",
  "energy-sumenergy",
  "energy-maxenergy",
  "energy-swell1energy",
  "energy-swell2energy",
  "energy-swell3energy",
  "energy-wwvenergy",
  "wind",
  "wind-state",
  "high-tide",
  "low-tide",
  "weather",
  "summary",
  "rain",
  "temperature-high",
  "chill",
  "feels",
  "sunrise",
  "sunset",
  "surf-period-1",
  "surf-period-2",
  "surf-period-3",
  "surf-period-w",
  "wavefinder-breaks-1",
  "wavefinder-rating-1",
  "distance",
  "wavefinder-breaks-2",
  "wavefinder-rating-2",
  "wavefinder-breaks-3",
  "wavefinder-rating-3",
].concat(swellKeys)

export function replace(Controller, fragment) {
  Controller.cells[0].parentNode.insertBefore(fragment, Controller.cells[0])
  Controller.cells.forEach((cell) => cell.remove())
}

export function fillFragment(newCells) {
  const fragment = document.createDocumentFragment()
  newCells.forEach((newCell) => {
    fragment.appendChild(newCell)
  })

  return fragment
}

function ReplacePlugin($pool) {
  return function run(eventName, payload) {
    const { Controller, newMode } = payload
    if (eventName !== "Row:changeMode") return
    if (!keys.includes(Controller.name)) return

    let fragment
    let newCells

    /* HACK: appending of the weather icons is a very slow op! Both SVG and webp + png */
    if (Controller.name === "weather") {
      newCells = payload[newMode].cells.map((cell) => cell.cloneNode(true))
      fragment = document.createDocumentFragment()

      newCells.forEach((newCell) => {
        $pool.push("Table:changeMode::idle", () => {
          fragment.appendChild(newCell)
        })
      })
    } else if (Controller.name === "wind") {
      newCells = payload[newMode].cells.map((cell) => cell.cloneNode(true))
      fragment = document.createDocumentFragment()

      newCells.forEach((newCell) => {
        WindIcon.init(newCell, {})
        $pool.push("Table:changeMode::idle", () => {
          fragment.appendChild(newCell)
        })
      })
    } else if (swellKeys.includes(Controller.name)) {
      newCells = payload[newMode].cells.map((cell) => cell.cloneNode(true))
      fragment = document.createDocumentFragment()

      newCells.forEach((newCell) => {
        initSwellIcons(newCell, Units)
        $pool.push("Table:changeMode::idle", () => {
          fragment.appendChild(newCell)
        })
      })
    } else {
      $pool.push("Table:changeMode::idle", () => {
        newCells = payload[newMode].cells.map((cell) => cell.cloneNode(true))
        fragment = fillFragment(newCells)
      })
    }

    $pool.push("Table:changeMode::mutate", () => {
      replace(Controller, fragment)

      // eslint-disable-next-line no-param-reassign
      payload.Controller.cells = newCells
    })
  }
}

export default ReplacePlugin
